<template>
  <application-layout>
    <v-container class="gift-card-container">
      <h1>Gift Cards</h1>
      <v-card class="mt-4">
        <v-form ref="searchForm">
          <v-container>
            <h2>Search by tenant name or email</h2>
            <v-layout>
              <v-flex xs3>
                <v-text-field
                  data-testid="gift-card-name-input"
                  class="gift-card-name-input mr-4"
                  v-model="payload.recipient_name"
                  :rules="!payload.email_address ? inputRules : []"
                  type="text"
                  label="Recipient Name"
                  filled
                  ref="searchInput"
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  data-testid="gift-card-email-input"
                  class="gift-card-email-input mr-4"
                  v-model="payload.email_address"
                  :rules="!payload.recipient_name ? emailRules : []"
                  type="email"
                  label="Email Address"
                  filled
                />
              </v-flex>
              <v-flex xs3 class="mt-1">
                <v-btn
                  data-testid="gift-card-submit-btn"
                  class="gift-card-submit-btn mr-4"
                  color="primary"
                  @click="handleGiftCardSearch"
                  :disabled="!validFields"
                >
                  Search
                </v-btn>
                <v-btn
                  data-testid="gift-card-reset-btn"
                  class="gift-card-reset-btn mr-4"
                  color="error"
                  @click="handleReset"
                  :disabled="!validFields"
                >
                  Reset
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
        <v-layout v-if="loadingStatus.includes('retrieving gift cards')" justify-center>
          <v-progress-circular
            :size="60"
            :width="6"
            indeterminate
            class="my-3"
          />
        </v-layout>
      <gift-card-table class="mt-4" v-else />
    </v-container>
  </application-layout>
</template>

<script>
import { emailRules, inputRules } from "@/helpers/form-rules";
import ApplicationLayout from "@/layouts/ApplicationLayout";
import GiftCardTable from "@/views/gift-cards/components/GiftCardTable";

export default {
  components: { ApplicationLayout, GiftCardTable },

  data() {
    return {
      emailRules: emailRules,
      inputRules: inputRules,
      payload: {
        recipient_name: "",
        email_address: ""
      }
    };
  },

  // ===== Methods ===== //
  methods: {
    handleGiftCardSearch() {
      this.$store.dispatch("getGiftCards", this.payload);
      this.$refs.searchForm.validate();
    },
    handleReset() {
      this.payload.recipient_name = "";
      this.payload.email_address = "";
      this.$store.dispatch("handleClearGiftCards");
      this.$refs.searchForm.reset();
    }
  },

  computed: {
    giftCards() {
      return this.$store.state.giftCards;
    },
    loadingStatus() {
      return this.giftCards.loadingState;
    },
    validFields() {
      return !!(this.payload.recipient_name || this.payload.email_address);
    }
  }
};
</script>

<style scoped>
  .gift-card-container {
    width: 80vw;
  }
</style>
